import { Guid } from 'guid-typescript';

export class AIMsError {
    id: Guid;
    code: string;
    description: string;
    active: boolean;
}